export const APP_CONFIG = {
  csApi: 'https://dev.tarifair.de',
  tariffCheckUrl: 'https://tarifair.de',
};
